import RequestService from '../../../services/request-service';

/**
 * Tournament Outrights Request Service
 */
export default class HorseRacingOutrightsRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.horseRacingOutrights;
    this.headers = null;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';

    const { Culture } = this.$config.defaultHeaders;
    this.getParams = {
      TournamentData: [],
      TournamentGroupData: [],
      TimeFilter: 100,
      Culture: Culture,
    };
  }
}
